<template>
  <b-row>
    <b-col>
      <div class="dash-element-pre-loader" v-if="loadingDasboardItems"></div>
      <b-row lg="12" v-else-if="noRequests" class="subtle-hints">
        <p>No Requests</p>
      </b-row>
      <b-row lg="12" v-for="(data, index) in requests" :key="data.id" class="dash-element-container">
        <b-row v-if="data.loading">
          <ContentLoader style="height:155; width:400">
            <rect x="200" y="15" rx="3" ry="3" width="185" height="20" />
            <rect x="200" y="70" rx="3" ry="3" width="113" height="15" />
            <rect x="200" y="105" rx="0" ry="0" width="90" height="40" />
            <rect x="12" y="15" rx="0" ry="0" width="180" height="120" />
            <rect x="310" y="105" rx="0" ry="0" width="90" height="40" />
          </ContentLoader>
        </b-row>
        <b-container v-else>
          <b-row>
            <b-col lg="4" md="4" sm="4" cols="4" class="dash-element-avatar">
              <md-avatar class="mo-xlarge">
                <img :src="data.prospectAvatar" alt="A">
              </md-avatar>
            </b-col>
            <b-col lg="8" md="8" sm="8" cols="8" class="dash-element-details-container">
              <md-button class="md-icon-button md-primary md-raised dash-element-btn ne"  @click="redirectToChat(data)">
                <md-icon>chat</md-icon>
              </md-button>
              <b-row class="single-line-row-fade dash-element-title-row">
                <span class="dash-element-title request-title">Inquiry | {{data.prospectName}}</span>
              </b-row>
              <b-row class="mt-2">
                <span>{{formatTimeToDDMMYYGate(data.periodStart)}} - {{formatTimeToDDMMYYGate(data.periodEnd)}}</span>
              </b-row>
              <b-row>
                <span>{{data.shortDesc}}</span>
              </b-row>
              <b-row>
                <span>{{data.addressFormatted}}</span>
              </b-row>
              <b-row class="mt-3 dash-listing-toolbar" align-v="end">
                <md-button :disabled="inquiryIsNotDismissable(data)" class="md-accent md-raised" @click="dismissRequestGate(data)">
                  <span>Dismiss</span>
                </md-button>
                <md-button class="md-primary md-raised" @click="viewRequestGate(data)">
                  <span>View</span>
                </md-button>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
  import { ContentLoader } from 'vue-content-loader'
  import {formatTimeToMonDD} from '../../functions.js'
  import {
    composeChatRedirectParams
  }from '../../chatRepository.js'
  export default {
    props: {
      viewRequest:{
        type:Function,
        required: true
      },
      loadingStatusChanged:{
        type: Function,
        required: true
      },
      dismissRequest:{
        type: Function,
        required: true
      },
      requests:{
        type: Array,
        required: true
      }
    },
    components: {
      ContentLoader
    },
    data() {
      return {
      }
    },
    computed: {
      noRequests(){
        return !(this.requests && this.requests.length > 0)
      },
      // dashRequests(){
      //   return this.$store.getters.dashRequests
      // },
      // dashRequestIds(){
      //   return this.$store.getters.dashRequestIds
      // }
    },
    created(){
      // if(!this.dashRequests || this.dashRequests.length <= 0) { //download requests if nothin in store
      //   this.getRequestsFromServer().then(response => {
      //     this.setRequestsToStore(response)
      //   })
      // }else this.checkForRequestUpdates() //check updates on each
    },
    methods: {
      inquiryIsNotDismissable(data){
        return data.status != "inquiry"
      },
      redirectToChat(data){
        this.$router.push({
          name: 'chat',
          params: composeChatRedirectParams(data.prospectUid, "", data.addressFormatted)
        })
      },
      dismissRequestGate(request){
        this.dismissRequest(request)
      },
      viewRequestGate(request){
        this.viewRequest(request.id)
        // TODO: navigate to listing management view with request id in the url
      },
      notifyError(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      },
      formatTimeToDDMMYYGate(date){
        return formatTimeToMonDD(date)
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/dashboard.css';
  @import '../../assets/styles/booking.css';
  @import '../../assets/styles/global.css';
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashRequests.vue